import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {Dropdown} from 'react-bootstrap'

type Props = {
  userType: string
  onOpenBulkUpload?: () => void
}

const UsersListToolbar: React.FC<Props> = ({userType, onOpenBulkUpload}) => {
  const {setItemIdForUpdate} = useListView()
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {userType == 'INTERPRETER' && (
        <>
          <OverlayTrigger
            placement='top'
            overlay={<Tooltip id='tooltip-filter'> Add Interpreter</Tooltip>}
          >
            <div>
              <button
                type='button'
                className='btn btn-sm btn-primary btn-icon ms-3'
                onClick={openAddUserModal}
              >
                <i className='bi bi-plus fs-2'></i>
              </button>
            </div>
          </OverlayTrigger>
        </>
      )}

      {userType == 'CONSUMER' && (
        <>
          <OverlayTrigger
            placement='top'
            overlay={<Tooltip id='tooltip-filter'> Add Requester</Tooltip>}
          >
            <div>
              <Dropdown align='end'>
                <Dropdown.Toggle
                  variant='primary'
                  id='add-requester-dropdown'
                  className='btn btn-sm btn-primary btn-icon ms-3 no-caret'
                >
                  <i className='bi bi-plus fs-2'></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={openAddUserModal}>Add Requester</Dropdown.Item>
                  <Dropdown.Item onClick={onOpenBulkUpload}>Add Bulk Requesters</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </OverlayTrigger>
        </>
      )}

      {userType == 'SYSTEM' && (
        <>
          <OverlayTrigger
            placement='top'
            overlay={<Tooltip id='tooltip-filter'> Add Administrator</Tooltip>}
          >
            <div>
              <button
                type='button'
                className='btn btn-sm btn-primary btn-icon ms-3'
                onClick={openAddUserModal}
              >
                <i className='bi bi-plus fs-2'></i>
              </button>
            </div>
          </OverlayTrigger>
        </>
      )}
    </div>
  )
}

export {UsersListToolbar}
